import React, { useEffect } from 'react';

import { DEV } from '@core/config';
import { useAuthContext } from '@hooks';
import { webCredentialsAPI } from '@utils/misc';

export function CredentialsProvider({
  children,
}: {
  children: JSX.Element;
}): React.ReactElement<{ children: React.ReactNode }> {
  const { isLoggedIn, login, loading } = useAuthContext();

  const autoSignIn = async () => {
    const credentials = (await navigator.credentials.get({
      password: true,
    } as any)) as any;
    // FIXME: Credential types are incorrect?
    // https://developer.mozilla.org/en-US/docs/Web/API/CredentialsContainer/get#Parameters

    if (credentials) {
      await login({
        email: credentials.id,
        password: credentials.password,
      });
    }
  };

  useEffect(() => {
    if (!isLoggedIn && !loading && webCredentialsAPI() && !DEV) {
      autoSignIn();
    }
  }, []);

  return children;
}
